import {
  Box,
  Code,
  Flex,
  HoverCard,
  Overlay,
  Stack,
  Text,
} from '@mantine/core';
import Button, { ButtonTypes } from '@/components/Buttons/Button';
import { useEffect, useState } from 'react';
import {
  useGetDiscussionCommentDataInDiscovery,
  useGetDiscussionDataInDiscovery,
} from '@/features/Discovery/Modal/DiscoveryContentDetailModal/hook/api';

import { ACTIVITY_TYPE } from '@/consts/Activity';
import { API_ENDPOINT } from '@/config/endpoint';
import CodeBlock from '@/components/CodeBlock';
import CommentContainer from '@/features/Common/components/Comment';
import ConfirmationPopup from '@/components/ConfirmationPopup';
import { IconCheck } from '@tabler/icons-react';
import Skeleton from '@/components/Skeleton';
import { createDiscoveryQuiz } from '@/features/Discovery/discovery.style';
import themeVariables from '@/styles/themeVariables';
import { useDisclosure } from '@mantine/hooks';

const COLOR = '100deg, #c2e9ff33 10%, #f4ddff33 90%';

const QuizBody = ({ id }) => {
  const { classes } = createDiscoveryQuiz();

  const [opened, { toggle }] = useDisclosure(false);
  const [timing, setTiming] = useState(false);

  const {
    data: topicData,
    refetch: refetchTopicData,
    isFetching,
  } = useGetDiscussionDataInDiscovery(id);

  const { data: comments, refetch: refetchComment } =
    useGetDiscussionCommentDataInDiscovery(id);

  useEffect(() => {
    setTimeout(() => {
      setTiming(true);
    }, 330);
  }, []);

  const submitAnswer = (item) => () => {
    !topicData?.item.answer_option_id &&
      ConfirmationPopup.confirm(
        <Stack spacing={4}>
          <Text
            p={4}
            size={16}
            weight={600}
            color={themeVariables.fontColors.medium}
            data-autofocus
          >
            옵션을 선택하시겠습니까?
          </Text>
          <Box p={8}>
            <Code mr={2}>{item?.title}</Code>
          </Box>
        </Stack>,
        () => {
          API_ENDPOINT.discussion.voteOption(id, item.id).then(() => {
            refetchTopicData();
          });
        }
      );
  };

  const OptionCard = ({ index, item }) => (
    <Box className={classes.optionCard} onClick={submitAnswer(item)}>
      <Text className={classes.optionCardText}>
        {index}.&nbsp;&nbsp;&nbsp;{item?.title}
      </Text>
    </Box>
  );

  if (isFetching) {
    return (
      <Stack mb={60}>
        <Skeleton lines={1} height={30} />
        <Skeleton isImage height={140} />
        <Skeleton isImage height={40} />
        <Skeleton isImage height={40} />
        <Skeleton isImage height={40} />
        <Skeleton isImage height={40} />
      </Stack>
    );
  }

  return (
    <Stack mb={60}>
      <Text className={classes.title}>* 정답률이 30% 미만인 문제에요 🙄</Text>
      <CodeBlock
        code={topicData?.item.content || ''}
        language={topicData?.item?.options[0].code_language}
      />
      <Box pos={'relative'} p={6}>
        {topicData?.item.answer_option_id && !opened && (
          <Overlay bg={'#ffffff00'} blur={8} center>
            <HoverCard
              withArrow
              arrowSize={10}
              width={'auto'}
              radius={'0.75rem'}
              position={'bottom'}
              shadow={themeVariables.boxShadow.popOverShadow}
            >
              <HoverCard.Target>
                <div>
                  <Button type={ButtonTypes.solidColored} onClick={toggle}>
                    정답 확인하기
                  </Button>
                </div>
              </HoverCard.Target>
              <HoverCard.Dropdown>
                <Text size={14} color={themeVariables.fontColors.medium}>
                  * 이 전에 이미 응답한 기록이 있어요
                </Text>
              </HoverCard.Dropdown>
            </HoverCard>
          </Overlay>
        )}
        <Stack mt={24} spacing={12}>
          {topicData?.item.options?.map((item, index) => {
            return !topicData?.item.answer_option_id ? (
              <OptionCard key={index} index={index} item={item} />
            ) : (
              <div key={index} className={classes.optionAnswerCard}>
                <Box
                  style={{
                    backgroundImage: `linear-gradient(${COLOR})`,
                    width: item.percent && timing ? `${item.percent}%` : '0%',
                    transition: item.percent ? 'width 0.33s linear' : '',
                    maxWidth: '100%',
                    padding: '12px 20px',
                  }}
                >
                  <Flex>
                    <Text
                      size={15}
                      weight={600}
                      color={themeVariables.fontColors.medium}
                    >
                      {index}.&nbsp;&nbsp;&nbsp;{item?.title}&nbsp;&nbsp;(
                      {item.percent}%
                    </Text>
                    <IconCheck
                      size={14}
                      stroke={3}
                      style={{ marginTop: 5, marginLeft: 5 }}
                    />
                    <Text
                      size={15}
                      weight={600}
                      color={themeVariables.fontColors.dark}
                    >
                      )
                    </Text>
                  </Flex>
                </Box>
              </div>
            );
          })}
        </Stack>
      </Box>
      <Box p={'60px 12px 24px'}>
        <CommentContainer
          topicData={topicData}
          comments={comments}
          refetchTopicData={refetchTopicData}
          refetchComment={refetchComment}
          type={ACTIVITY_TYPE.discussion}
        />
      </Box>
    </Stack>
  );
};

export default QuizBody;
